import {Change} from 'diff';
import React from 'react';

export default function getTextDifferences(results: Change[]): React.ReactNode[] {
  return results.map((part, index) => {
    if (part.added) {
      return (
        <span className="green-highlighting" key={index}>
          {part.value}
        </span>
      );
    } else if (!part.removed) {
      return part.value;
    }
  });
}
